import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import { clearAndGetFilters, setInitialFilters } from './../filters/operations';
import * as selectors from './selectors';
import * as actions from './actions';
import * as generalSelectors from './../general/selectors';
import * as generalActions from './../general/actions';
import { META_SKIP_ERROR_PAGE } from '../../constants';

import { operations } from './index';

export const getTrends = (meta = META_SKIP_ERROR_PAGE) => (dispatch, getState) => (
  dispatch(actions.getTestTrends(selectors.trendsTestsParamsSelector(getState()), meta))
);

export const getTestErrors = (meta = META_SKIP_ERROR_PAGE) => (dispatch, getState) => (
  dispatch(actions.getTestErrors(selectors.trendsTestsParamsSelector(getState()), meta))
);

export const getBuildsTests = (meta = META_SKIP_ERROR_PAGE) => (dispatch, getState) => (
  dispatch(actions.getBuildsTests(selectors.buildsRequestParamsSelector(getState()), meta))
);

export const getTests = (newPage, meta = META_SKIP_ERROR_PAGE) => (dispatch, getState) => (
  dispatch(actions.getTests(selectors.testsParamsSelector(getState(), { newPage }), meta))
);

export const getTestsByBuild = (
  newPage, build, meta = META_SKIP_ERROR_PAGE,
) => (dispatch, getState) => (
  dispatch(newPage === 1 ?
    actions.setTestsByBuild(selectors.getTestsFromBuild(getState(), { build })) :
    actions.getTestsByBuild(selectors.testsParamsSelector(getState(), { newPage, build }), meta),
  )
);

export const updateData = (meta = META_SKIP_ERROR_PAGE) => (dispatch) => Promise.all([
  dispatch(operations.getTrends(meta)),
  dispatch(operations.getTestErrors(meta)),
  dispatch(operations.getBuildsTests(meta)),
]);

export const clearFilters = (location) => (dispatch) => Promise.all([
  dispatch(clearAndGetFilters(null, { location })),
  dispatch(operations.updateData()),
]);

export const updateStatus = (status, meta = META_SKIP_ERROR_PAGE) => (dispatch) => Promise.all([
  dispatch(actions.setStatusFilter(status)),
  dispatch(operations.getBuildsTests(meta)),
]);

export const changeTestsPage = (newPage, meta = META_SKIP_ERROR_PAGE) => (dispatch) => Promise.all([
  dispatch(actions.setCurrentPage(newPage)),
  dispatch(operations.getTests(newPage, meta)),
]);

export const loadInitData = (meta = META_SKIP_ERROR_PAGE) => (dispatch, getState) => (
  dispatch(generalActions.loadInitData(
    Promise.all([
      dispatch(clearAndGetFilters()),
      dispatch(setInitialFilters(...generalSelectors.initialFilterSelector(getState()))),
    ]).then(() => dispatch(operations.updateData(meta),
    )).catch((error) => {
      dispatch(notificationActions.notifyDanger(
        error.message, 'We\'ve experienced an issue while loading data.', true,
      ));
    }),
  ))
);
